export function formatNumber(number: number|string|null|undefined): string {
    if (!number) return "0";

    number = number.toString().replace(",", ".").toNumber();

    if (number === 0) return "0";

    return new Intl.NumberFormat('nl-NL', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number);
}

export function formatUnixTimestamp(timestamp: number|undefined): string {
    if (!timestamp) return "";

    const date = new Date(timestamp * 1000);

    return new Intl.DateTimeFormat('nl-NL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(date).replace(/\//g, '-');
}

export function dateToDutch(value: string): string {
    return new Intl.DateTimeFormat('nl-NL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(new Date(value));
}

export function toEuroValue(number: number|string|null|undefined): number {
    if (!number) return 0;

    number = number.toString().replace(",", ".").toNumber();

    return Number(number);
}